import Vue from 'vue'
import VueCookies from 'vue-cookies'
import vuetify from './plugins/vuetify';
import Toast2 from "vuetify-toast2"

import App from './App'
import router from './router'
import store from './store'

// Import flag-icons CSS for cross-platform flag support
import 'flag-icons/css/flag-icons.min.css'


import VueClipboard from 'vue-clipboard2'

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.use(Toast2)
Vue.component('apexchart', VueApexCharts)

import PortalVue from "portal-vue";
Vue.use(PortalVue);



const moment = require('moment')
require('moment/locale/de');


Vue.use(require('vue-moment'), {
  moment
})

Vue.config.devtools = true
Vue.config.productionTip = false

Vue.use(VueCookies)
VueCookies.config('7d');

Vue.use(VueClipboard)


export const serverBus = new Vue();

import AuthService from './services/AuthService';

Vue.prototype.$authService = AuthService;

new Vue({
  router,
  store,
  vuetify,
  template: '<App/>',
  components: { App }
}).$mount('#app')

